const TEXTS = {
    en: {
        home: {
            collapseToggleCollapse: "Collapse",
            collapseToggleExpand: "Learn more",
            header: "We put your privacy first.",
            bodyCollapsedLead: "Our website uses cookies.",
            bodyLead: "Our website uses the following types of cookies. You are free to accept each of them individually.",
            bodyCompactLead: "We use cookies to enhance your experience on our website. You can update your preferences.",
            cookiesNecessary: "Necessary cookies",
            cookiesNecessaryTooltip: "Necessary cookies are essential for the use of the website and its functionalities. These cookies ensure, for example, that you can navigate from page to page without the information entered in a form or the products placed in a basket disappearing. Necessary cookies cannot be disabled.",
            cookiesStatistics: "Statistics cookies",
            cookiesStatisticsTooltip: "Statistics cookies collect information on how websites are used and allow us to carry out analyses, for example on the most consulted pages and the navigation of visitors on a website. These cookies are used to simplify and speed up the visit to the website and, overall, to improve user comfort.",
            cookiesMarketing: "Marketing cookies",
            cookiesMarketingTooltip: "Marketing cookies help us and our advertising partners to provide you with advertising on our websites and those of third parties for products or services that may be of interest to you, or to display our advertisements when you continue to browse the Internet after leaving our websites.",
            cookiesPreferences: "Preferences cookies",
            cookiesPreferenceseTooltip: "Preferences cookies allow us to offer advanced features and display personalized content. These cookies allow us, for example, to save the information already provided (such as the choice of language) or to show you products that you might also like based on the articles consulted.",
            privacyPolicyLead: "Consult our",
            privacyPolicyLinkedText: "privacy policy",
            linkRejectAll: "Continue without accepting",
            buttonRejectAll: "Reject All",
            buttonAcceptAll: "Accept All",
            buttonCustomize: "Customize",
            biskouiSignaturePre: "The ",
            biskouiSignatureSwiss: "Swiss",
            biskouiSignaturePost: " Consent by ",
        },
        customize: {
            header: "Your visit, your choice",
            bodyLead: "Which cookies do you want to accept?",
            labelAcceptAll: "Accept all",
            cookieType: {
                necessary: "Necessary cookie",
                statistics: "Statistics cookie",
                marketing: "Marketing cookie",
                preferences: "Preferences cookie",
            },
            privacyPolicyLead: "Consult our",
            privacyPolicyLinkedText: "privacy policy",
            buttonConfirm: "Confirm",
        },
        blocked: {
            text: "Oops! The consent module is disabled. Please contact your administrator.",
            buttonClose: "Close",
        },
    },
    fr: {
        home: {
            collapseToggleCollapse: "Réduire",
            collapseToggleExpand: "En savoir plus",
            header: "Nous mettons votre confidentialité en priorité.",
            bodyCollapsedLead: "Notre site Internet utilise des cookies.",
            bodyLead: "Notre site Internet utilise les types de cookies suivants tout en vous laissant le libre choix d'accepter leur utilisation:",
            bodyCompactLead: "Nous utilisons des cookies pour améliorer votre expérience sur notre site web. Vous pouvez mettre à jour vos préférences.",
            cookiesNecessary: "Cookies nécessaires",
            cookiesNecessaryTooltip: "Les cookies nécessaires sont indispensables à l'utilisation du site web et de ses fonctionnalités. Ces cookies vous assurent par exemple de pouvoir naviguer de page en page sans que les informations saisies dans un formulaire ou les produits placés dans un panier ne disparaissent. Les cookies nécessaires ne peuvent pas être désactivés.",
            cookiesStatistics: "Cookies de performance",
            cookiesStatisticsTooltip: "Les cookies de performance collectent des informations sur le mode d'utilisation des sites web et nous permettent de réaliser des analyses, par exemple sur les pages les plus consultées et la navigation des visiteurs/visiteuses sur un site web. Ces cookies servent à simplifier et accélérer la visite du site web et, dans l'ensemble, à améliorer le confort d'utilisation.",
            cookiesMarketing: "Cookies marketing",
            cookiesMarketingTooltip: "Les cookies marketing nous aident et aident nos partenaires publicitaires à vous proposer sur nos sites web et ceux de tiers de la publicité pour des produits ou des services qui pourraient vous intéresser, ou à afficher nos annonces publicitaires lorsque vous poursuivez votre navigation sur Internet après avoir quitté nos sites web.",
            cookiesPreferences: "Cookies fonctionnels",
            cookiesPreferenceseTooltip: "Les cookies fonctionnels nous permettent de proposer des fonctionnalités avancées et d'afficher des contenus personnalisés. Ces cookies nous permettent par exemple d'enregistrer les informations déjà fournies (telles que le choix de la langue) ou de vous montrer des produits qui pourraient également vous plaire sur la base des articles consultés.",
            privacyPolicyLead: "Consultez notre",
            privacyPolicyLinkedText: "politique de confidentialité",
            linkRejectAll: "Continuer sans accepter",
            buttonRejectAll: "Tout Refuser",
            buttonAcceptAll: "Tout Accepter",
            buttonCustomize: "Laissez-moi choisir",
            biskouiSignaturePre: "Le Consentement ",
            biskouiSignatureSwiss: "Suisse",
            biskouiSignaturePost: " par ",
        },
        customize: {
            header: "Votre visite, vos préférences.",
            bodyLead: "Quels cookies souhaitez-vous accepter ?",
            labelAcceptAll: "Tout accepter",
            cookieType: {
                necessary: "Cookie nécessaires",
                statistics: "Cookie de performance",
                marketing: "Cookie marketing",
                preferences: "Cookie fonctionnels",
            },
            privacyPolicyLead: "Consultez notre",
            privacyPolicyLinkedText: "politique de confidentialité",
            buttonConfirm: "Confirmer ma selection",
        },
        blocked: {
            text: "Oops ! Le module de consentement est desactivé. Veuillez contacter votre administrateur.",
            buttonClose: "Fermer",
        }
    },
    de: {
        home: {
            collapseToggleCollapse: "Einklappen",
            collapseToggleExpand: "Mehr erfahren",
            header: "Wir stellen Ihre Privatsphäre an erste Stelle.",
            bodyCollapsedLead: "Unsere Webseite verwendet Cookies.",
            bodyLead: "Unsere Webseite verwendet die folgenden Cookies. Sie können selbst bestimmen, für welche dieser Cookies Sie Ihre Einwilligung erteilen.",
            bodyCompactLead: "Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Sie können Ihre Präferenzen aktualisieren.",
            cookiesNecessary: "Notwendige Cookies",
            cookiesNecessaryTooltip: "Notwendige Cookies ermöglichen Ihnen die Navigation und die Nutzung grundlegender Funktionen, wie z. B. die Speicherung von Informationen, die Sie in ein Formular eingegeben haben, oder die Speicherung von Produkten, die Sie in den Warenkorb gelegt haben. Notwendige Cookies können nicht deaktiviert werden.",
            cookiesStatistics: "Analyse-Cookies",
            cookiesStatisticsTooltip: "Analyse-Cookies werden verwendet, um Informationen darüber zu sammeln, wie Besucher mit unserer Webseite interagieren. Damit können wir die Zugriffe auf unsere Webseite, das Nutzerverhalten und andere Kennzahlen analysieren und messen, und so die Leistung unserer Webseite und das Nutzererlebnis stets verbessern.",
            cookiesMarketing: "Marketing-Cookies",
            cookiesMarketingTooltip: "Marketing-Cookies helfen uns und unseren Marketingpartnern, Ihnen auf unserer Webseite oder auf Webseiten Dritter Produkte oder Dienstleistungen vorzuschlagen, die Sie interessieren könnten. Wir könnten Ihnen auch Werbung anzeigen, wenn Sie nach dem Verlassen unserer Webseite weiter im Internet surfen.",
            cookiesPreferences: "Funktionale Cookies",
            cookiesPreferenceseTooltip: "Funktionale Cookies ermöglichen es uns, Ihnen erweiterte Funktionen anzubieten und personalisierte Inhalte anzuzeigen, um Ihnen ein besseres Erlebnis zu bieten. Diese Cookies werden verwendet, um Informationen wie Benutzerpräferenzen, Spracheinstellungen, Standortpräferenzen und andere ähnliche Einstellungen zu speichern. Es ist wichtig zu beachten, dass sich funktionale Cookies von Analyse- oder Marketing-Cookies unterscheiden, da sie sich in erster Linie auf die Speicherung von Nutzerpräferenzen auf unserer Website konzentrieren.",
            privacyPolicyLead: "Konsultieren Sie unsere",
            privacyPolicyLinkedText: "Datenschutzerklärung",
            linkRejectAll: "Weiter ohne akzeptieren",
            buttonRejectAll: "Alle ablehnen",
            buttonAcceptAll: "Alle akzeptieren",
            buttonCustomize: "Ich möchte wählen",
            biskouiSignaturePre: "Die ",
            biskouiSignatureSwiss: "Schweizer",
            biskouiSignaturePost: " Einwilligung by ",
        },
        customize: {
            header: "Ihr Besuch, Ihre Wahl",
            bodyLead: "Welche Cookies möchten Sie akzeptieren?",
            labelAcceptAll: "Alle akzeptieren",
            cookieType: {
                necessary: "Notwendige Cookie",
                statistics: "Analyse-Cookie",
                marketing: "Marketing-Cookie",
                preferences: "Funktionale Cookie",
            },
            privacyPolicyLead: "Konsultieren Sie unsere",
            privacyPolicyLinkedText: "Datenschutzerklärung",
            buttonConfirm: "Auswahl bestätigen",
        },
        blocked: {
            text: "Ups! Das Zustimmungsmodul ist deaktiviert. Bitte kontaktieren Sie Ihren Administrator.",
            buttonClose: "Schließen",
        }
    },
    it: {
        home: {
            collapseToggleCollapse: "Comprimi",
            collapseToggleExpand: "Scopri di più",
            header: "Mettiamo la tua privacy al primo posto.",
            bodyCollapsedLead: "Il nostro sito web utilizza i cookie.",
            bodyLead: "Il nostro sito web utilizza i seguenti tipi di cookie. Puoi scegliere di accettare ognuno di essi individualmente:",
            bodyCompactLead: "Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito web. Puoi aggiornare le tue preferenze",
            cookiesNecessary: "Cookie strettamente necessari",
            cookiesNecessaryTooltip: "Questi cookie sono necessari per il corretto funzionamento del sito, e ti permettono di navigare e accedere a funzionalità base come salvare le informazioni da te fornite attraverso dei moduli e non perdere i prodotti presenti nel carrello. I cookie strettamente necessari non possono essere disattivati.",
            cookiesStatistics: "Cookie di prestazione",
            cookiesStatisticsTooltip: "Questi cookie sono utilizzati per raccogliere informazioni su come i visitatori interagiscono con il nostro sito web. Ci permettono di analizzare e misurare il traffico sul sito, il comportamento dei consumatori e altre metriche per migliorare le prestazioni e l'esperienza utente del nostro sito.",
            cookiesMarketing: "Cookie per pubblicità mirata",
            cookiesMarketingTooltip: "Questi cookie aiutano noi e i nostri partner pubblicitari a mostrarti, sul nostro sito o su quelli di terze parti, prodotti o servizi che possano essere di tuo interesse. Inoltre, dopo essere uscito dal nostro sito, potremmo mostrarti alcuni annunci durante la tua navigazione sul web.",
            cookiesPreferences: "Cookie di funzionalità",
            cookiesPreferenceseTooltip: "Questi cookie ci permettono di offrirti funzionalità avanzate e mostrarti contenuti personalizzati per una migliore esperienza sul nostro sito. Questi cookie sono utilizzati per ricordare determinate informazioni come le preferenze utente, la lingua selezionata, la località preferita, e altre impostazioni simili. È importante notare che i cookie di funzionalità sono diversi dai cookie per pubblicità mirata, in quanto il loro scopo è di ricordare le preferenze utente solo ed esclusivamente sul nostro sito web.",
            privacyPolicyLead: "Consulta la nostra",
            privacyPolicyLinkedText: "informativa sulla privacy",
            linkRejectAll: "Continua senza accettare",
            buttonRejectAll: "Rifiuta tutto",
            buttonAcceptAll: "Accetta tutto",
            buttonCustomize: "Voglio decidere io.",
            biskouiSignaturePre: "The ",
            biskouiSignatureSwiss: "Swiss",
            biskouiSignaturePost: " Consent by ",
        },
        customize: {
            header: "Tua la visita, tua la scelta.",
            bodyLead: "Quali cookie vuoi accettare?",
            labelAcceptAll: "Accetta tutto",
            cookieType: {
                necessary: "Cookie strettamente necessari",
                statistics: "Cookie di prestazione",
                marketing: "Cookie per pubblicità mirata",
                preferences: "Cookie di funzionalità",
            },
            privacyPolicyLead: "Consulta la nostra",
            privacyPolicyLinkedText: "informativa sulla privacy",
            buttonConfirm: "Conferma la mia selezione",
        },
        blocked: {
            text: "Ops! Il modulo di consenso è disattivato. Si prega di contattare il proprio amministratore.",
            buttonClose: "Chiudi",
        }
    },
    bg: {
        home: {
            collapseToggleCollapse: "Свиване",
            collapseToggleExpand: "Научете повече",
            header: "Ние поставяме вашата поверителност на първо място.",
            bodyCollapsedLead: "Нашият уебсайт използва бисквитки",
            bodyLead: "Нашият уебсайт използва следните видове бисквитки. Вие можете да приемете всяка от тях поотделно:",
            bodyCompactLead: "Използваме бисквитки, за да подобрим вашето преживяване на нашия уебсайт. Можете да актуализирате предпочитанията си",
            cookiesNecessary: "Необходими бисквитки",
            cookiesNecessaryTooltip: "Необходимите бисквитки са от съществено значение за правилната работа на нашия уебсайт, те Ви позволяват да навигирате и да използвате основни функции, като запазване на информация, предоставена във формуляр, или да не губите продукти поставени в пазарска количка. Необходимите бисквитки не могат да бъдат деактивирани.",
            cookiesStatistics: "Бисквитки за анализ",
            cookiesStatisticsTooltip: "Бисквитките за анализ се използват за събиране на информация за това как посетителите взаимодействат с нашия уебсайт. Това ни позволява да анализираме и измерваме трафика на уебсайта, поведението на потребителите и други показатели, за да подобрим ефективността на нашия уебсайт и потребителското изживяване.",
            cookiesMarketing: "Бисквитки за реклама",
            cookiesMarketingTooltip: "Бисквитките за реклама помагат на нас и нашите маркетингови партньори да Ви предложим, на нашия уебсайт или уебсайтове на трети страни, определени продукти или услуги, които може да представляват интерес за вас. Може също така да ви покажем някои реклами, докато продължавате да сърфирате в интернет, след като напуснете нашия уебсайт.",
            cookiesPreferences: "Функционални бисквитки",
            cookiesPreferenceseTooltip: "Функционалните бисквитки ни позволяват да Ви предложим разширени функционалности и да показваме персонализирано съдържание за по-добро изживяване. Тези бисквитки се използват за съхраняване на информация като потребителски предпочитания, езикови настройки, предпочитания за местоположение и други подобни настройки. Важно е да се отбележи, че функционалните бисквитки се различават от бисквитките за анализ или бисквитките за маркетинг, тъй като те основно се фокусират върху запомнянето на потребителските предпочитания само на нашия уебсайт.",
            privacyPolicyLead: "Консултирайте се с нашите",
            privacyPolicyLinkedText: "политика за поверителност",
            linkRejectAll: "Продължете без да приемате",
            buttonRejectAll: "Отхвърляне на всички",
            buttonAcceptAll: "Приемам всички",
            buttonCustomize: "Искам да избера",
            biskouiSignaturePre: "The ",
            biskouiSignatureSwiss: "Swiss",
            biskouiSignaturePost: " Consent by ",
        },
        customize: {
            header: "Вашето посещение, вашият избор.",
            bodyLead: "Кои бисквитки искате да приемете?",
            labelAcceptAll: "Приемам всички",
            cookieType: {
                necessary: "Необходими бисквитки",
                statistics: "Бисквитки за анализ",
                marketing: "Бисквитки за реклама",
                preferences: "Функционални бисквитки",
            },
            privacyPolicyLead: "Консултирайте се с нашите",
            privacyPolicyLinkedText: "политика за поверителност",
            buttonConfirm: "Потвърждавам моя избор",
        },
        blocked: {
            text: "Опа! Модулът за съгласие е деактивиран. Моля, свържете се с администратора си.",
            buttonClose: "Затвори",
        }
    },
    es: {
        home: {
            collapseToggleCollapse: "Colapsar",
            collapseToggleExpand: "Aprende más",
            header: "Ponemos tu privacidad en primer lugar.",
            bodyCollapsedLead: "Nuestro sitio web utiliza cookies.",
            bodyLead: "Nuestro sitio web utiliza los siguientes tipos de cookies. Usted es libre de aceptar cada una de ellas individualmente:",
            bodyCompactLead: "Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Puede actualizar sus preferencias",
            cookiesNecessary: "Cookies necesarias",
            cookiesNecessaryTooltip: "Las cookies necesarias son esenciales para que nuestro sitio web funcione correctamente, permitiéndole navegar y utilizar funciones básicas como guardar la información proporcionada en un formulario o no perder los productos colocados en el carrito de compras. Las cookies necesarias no pueden desactivarse.",
            cookiesStatistics: "Cookies analíticas",
            cookiesStatisticsTooltip: "La cookies analíticas se utilizan para recopilar información sobre cómo interactúan los visitantes con nuestro sitio web. Nos permite analizar y medir el tráfico del sitio web, el comportamiento de los usuarios y otras métricas para mejorar el rendimiento de nuestro sitio web y la experiencia de los usuarios.",
            cookiesMarketing: "Cookies de marketing",
            cookiesMarketingTooltip: "Las cookies de marketing nos ayudan a nosotros y a nuestros socios de marketing a proponerle, en nuestro sitio web o de terceros, algunos productos o servicios que pudieran interesarle. También podemos mostrarle algunos anuncios mientras sigue navegando por Internet despues de salir de nuestro sitio web.",
            cookiesPreferences: "Cookies Funcionales",
            cookiesPreferenceseTooltip: "Las cookies funcionales nos permiten ofrecerle funcionalidades avanzadas y mostrarle contenido personalizado para una mejor experiencia. Estas cookies se utilizan para almacenar información como las preferencias del usuario, los ajustes de idioma, las preferencias de ubicación y otros ajustes similares. Es importante señalar que las cookies funcionales difieren de las cookies analíticas o de marketing, ya que se centran principalmente en recordar las preferencias del usuario en nuestro sitio web.",
            privacyPolicyLead: "Consulte nuestro",
            privacyPolicyLinkedText: "política de privacidad",
            linkRejectAll: "Continuar sin aceptar",
            buttonRejectAll: "Rechazar todo",
            buttonAcceptAll: "Aceptar todo",
            buttonCustomize: "Quiero elegir",
            biskouiSignaturePre: "El ",
            biskouiSignatureSwiss: "Suizo",
            biskouiSignaturePost: " Consentimiento por ",
        },
        customize: {
            header: "Su visita, su elección.",
            bodyLead: "¿Qué cookies desea aceptar?",
            labelAcceptAll: "Aceptar todo",
            cookieType: {
                necessary: "Cookies necesarias",
                statistics: "Cookies analíticas",
                marketing: "Cookies de marketing",
                preferences: "Cookies Funcionales",
            },
            privacyPolicyLead: "Consulte nuestro",
            privacyPolicyLinkedText: "política de privacidad",
            buttonConfirm: "Confirmar mi selección",
        },
        blocked: {
            text: "Ups! El módulo de consentimiento está desactivado. Por favor, contacta a tu administrador.",
            buttonClose: "Cerrar",
        }
    },
    pt: {
        home: {
            collapseToggleCollapse: "Colapso",
            collapseToggleExpand: "Saber mais",
            header: "Colocamos sua privacidade em primeiro lugar.",
            bodyCollapsedLead: "Nosso site usa cookies.",
            bodyLead: "O nosso website utiliza os seguintes tipos de cookies. O utilizador é livre de aceitar cada um deles individualmente:",
            bodyCompactLead: "Utilizamos cookies para melhorar a sua experiência no nosso website. Pode atualizar as suas preferências",
            cookiesNecessary: "Cookies necessários",
            cookiesNecessaryTooltip: "Os cookies estritamente necessários são essenciais para que o nosso website funcione corretamente, permitindo-lhe navegar e utilizar funcionalidades básicas, como guardar informações fornecidas num formulário ou evitar a perda de produtos colocados no carrinho de compras. Os cookies estritamente necessários não podem ser desativados.",
            cookiesStatistics: "Cookies analíticos",
            cookiesStatisticsTooltip: "Os cookies analíticos são utilizados para recolher informações sobre a forma como os visitantes interagem com o nosso website. Permitem-nos analisar e medir o tráfego do website, o comportamento do utilizador e outras métricas para melhorar o desempenho do nosso website e a experiência do utilizador.",
            cookiesMarketing: "Cookies de publicidade",
            cookiesMarketingTooltip: "Os cookies de publicidade ajudam-nos a nós e aos nossos parceiros de publicidade a propor-lhe, no nosso ou em outros websites, alguns produtos ou serviços que possam interessar-lhe. Podemos também apresentar-lhe alguns anúncios enquanto continua a navegar na Internet depois de sair do nosso website.",
            cookiesPreferences: "Cookies funcionais",
            cookiesPreferenceseTooltip: "Os cookies funcionais permitem-nos oferecer ao utilizador funcionalidades avançadas e apresentar conteúdos personalizados para uma melhor experiência. Estes cookies são utilizados para armazenar informações como as preferências do utilizador, definições de idioma, preferências de localização e outras definições semelhantes. É importante notar que os cookies funcionais diferem dos cookies analíticos ou de publicidade, uma vez que se concentram principalmente em recordar as preferências do utilizador apenas no nosso website.",
            privacyPolicyLead: "Consulte a nossa",
            privacyPolicyLinkedText: "política de privacidade",
            linkRejectAll: "Continuar sem aceitar",
            buttonRejectAll: "Rejeitar Tudo",
            buttonAcceptAll: "Aceitar Tudo",
            buttonCustomize: "Quero escolher",
            biskouiSignaturePre: "O ",
            biskouiSignatureSwiss: "Suíço",
            biskouiSignaturePost: " Consentimento por ",
        },
        customize: {
            header: "A sua visita, a sua escolha.",
            bodyLead: "Que cookies pretende aceitar?",
            labelAcceptAll: "Aceitar todos",
            cookieType: {
                necessary: "Cookies necessários",
                statistics: "Cookies analíticos",
                marketing: "Cookies de publicidade",
                preferences: "Cookies funcionais",
            },
            privacyPolicyLead: "Consulte a nossa",
            privacyPolicyLinkedText: "política de privacidade",
            buttonConfirm: "Confirmar a minha seleção",
        },
        blocked: {
            text: "Ops! O módulo de consentimento está desativado. Por favor, contate o seu administrador.",
            buttonClose: "Fechar",
        }
    },
    rm: {
        home: {
            collapseToggleCollapse: "Reducir",
            collapseToggleExpand: "Dapli infurmaziuns",
            header: "Nus mettain Vossa sfera privata en l'emprim plaz.",
            bodyCollapsedLead: "Nossa pagina d'internet fa diever da cookies.",
            bodyLead: "Nossa pagina d'internet fa diever dals suandants tips da cookies. Vus pudais acceptar mintgin en moda individuala:",
            bodyCompactLead: "Nus utilisain cookies per meglierar vossa experientscha sin nossa pagina d'internet. Vus pudais actualisar vossas preferenzas",
            cookiesNecessary: "Cookies necessarias",
            cookiesNecessaryTooltip: "Cookies necessaris èn indispensabels per nossa pagina d'internet, per ch'els lavurian correctamain, uschia As pussibilitescha da navigar en e da duvrar funcziuns da basa sco p.ex. spargnar infurmaziuns fatgas en in formular u betg per perder products che vegnan mess en in char da cumpra. Cuschinar necessaris na pon betg vegnir impedids.",
            cookiesStatistics: "Cookies analiticas",
            cookiesStatisticsTooltip: "Cun cookies cun analitics vegnan rimnadas infurmaziuns davart co che las visitadras ed ils visitaders interageschan cun nossa pagina d'internet. Quella ans permetta d'analisar e da mesirar il traffic da la pagina d'internet, il cumportament d'utilisader ed auters metrics, per meglierar las prestaziuns e las experientschas d'utilisader da nossa pagina d'internet.",
            cookiesMarketing: "Cookies da reclama",
            cookiesMarketingTooltip: "Cookies da reclama ans gidan da porscher a Vus e noss partenaris da marketing, sin nossa pagina d'internet u sin autras paginas d'internet u sin auters posts, tscherts products u servetschs che pon s'interessar per Vus. En quest connex pudain nus er mussar tscherts inserats durant che Vus navigais vinavant en l'internet, suenter ch'ins bandunais nossa pagina.",
            cookiesPreferences: "Cookies funcziuns",
            cookiesPreferenceseTooltip: "Cookies cun funcziuns ans permettan d'offrir a Vus funcziuns avanzadas e da mussar cuntegns individuals per far megliera experientscha. Quests cuschiniers servan per arcunar infurmaziuns sco preferenzas d'utilisader, opiniuns da lingua, preferenzas dal lieu ed auters arranschaments sumegliants. Impurtant è da resguardar che cuschiniers funcziunals sa differenzieschan da cuschiniers da l'analitica u da marketing, perquai ch'els sa concentreschan primarmain sin regurdar da preferenzas dals utilisaders sin nossa pagina Web.",
            privacyPolicyLead: "Nossadunna",
            privacyPolicyLinkedText: "politica da sfera privata",
            linkRejectAll: "Cuntinuar senza acceptar",
            buttonRejectAll: "Refusar All",
            buttonAcceptAll: "Accept Alle",
            buttonCustomize: "Jau vuless eleger",
            biskouiSignaturePre: "Il ",
            biskouiSignatureSwiss: "Svizzer",
            biskouiSignaturePost: " Consentiment da ",
        },
        customize: {
            header: "Vossa visita, Vossa elecziun.",
            bodyLead: "Tge cookies vulais vus acceptar?",
            labelAcceptAll: "Aceitar todos",
            cookieType: {
                necessary: "Cookies necessarias",
                statistics: "Cookies analiticas",
                marketing: "Cookies da reclama",
                preferences: "Cookies funcziuns",
            },
            privacyPolicyLead: "Nossadunna",
            privacyPolicyLinkedText: "politica da sfera privata",
            buttonConfirm: "Confermar mia tscherna",
        },
        blocked: {
            text: "Ups! Il modul da consentiment è deactivà. Per plaschair contactai voss administratur.",
            buttonClose: "Serrar",
        },
    },
    sv: {
        home: {
            collapseToggleCollapse: "Minimera",
            collapseToggleExpand: "Läs mer",
            header: "Vi sätter din integritet främst.",
            bodyCollapsedLead: "Vår webbplats använder cookies.",
            bodyLead: "Vår webbplats använder följande typer av cookies. Du kan välja att acceptera var och en av dem individuellt:",
            bodyCompactLead: "Vi använder cookies för att förbättra din upplevelse på vår webbplats. Du kan uppdatera dina preferenser",
            cookiesNecessary: "Nödvändiga cookies",
            cookiesNecessaryTooltip: "Nödvändiga cookies är viktiga för att webbplatsen och dess funktioner ska fungera korrekt. Dessa cookies ser till att du till exempel kan navigera mellan sidor utan att information som angetts i ett formulär eller produkter som placerats i en kundvagn försvinner. Nödvändiga cookies kan inte inaktiveras.",
            cookiesStatistics: "Statistik-cookies",
            cookiesStatisticsTooltip: "Statistik-cookies samlar in information om hur webbplatser används och låter oss genomföra analyser, till exempel om de mest besökta sidorna och besökarnas navigation på webbplatsen. Dessa cookies används för att förenkla och snabba upp besöket på webbplatsen och för att förbättra användarupplevelsen.",
            cookiesMarketing: "Marknadsförings-cookies",
            cookiesMarketingTooltip: "Marknadsförings-cookies hjälper oss och våra marknadsföringspartners att visa dig annonser på våra och andras webbplatser för produkter eller tjänster som kan intressera dig, eller att visa våra annonser när du fortsätter att surfa på internet efter att ha lämnat våra webbplatser.",
            cookiesPreferences: "Preferens-cookies",
            cookiesPreferenceseTooltip: "Preferens-cookies låter oss erbjuda avancerade funktioner och visa personligt innehåll. Dessa cookies låter oss till exempel spara information som redan angetts (som språkval) eller visa produkter som du kan vara intresserad av baserat på tidigare visade artiklar.",
            privacyPolicyLead: "Läs vår",
            privacyPolicyLinkedText: "integritetspolicy",
            linkRejectAll: "Fortsätt utan att acceptera",
            buttonRejectAll: "Avvisa alla",
            buttonAcceptAll: "Acceptera alla",
            buttonCustomize: "Anpassa val",
            biskouiSignaturePre: "Det ",
            biskouiSignatureSwiss: "Schweiziska",
            biskouiSignaturePost: " Samtycket av ",
        },
        customize: {
            header: "Ditt besök, ditt val",
            bodyLead: "Vilka cookies vill du acceptera?",
            labelAcceptAll: "Acceptera alla",
            cookieType: {
                necessary: "Nödvändiga cookies",
                statistics: "Statistik-cookies",
                marketing: "Marknadsförings-cookies",
                preferences: "Preferens-cookies",
            },
            privacyPolicyLead: "Läs vår",
            privacyPolicyLinkedText: "integritetspolicy",
            buttonConfirm: "Bekräfta mitt val",
        },
        blocked: {
            text: "Hoppsan! Samtyckesmodulen är inaktiverad. Vänligen kontakta din administratör.",
            buttonClose: "Stäng",
        },
    },
    nl: {
        home: {
            collapseToggleCollapse: "Inklappen",
            collapseToggleExpand: "Meer informatie",
            header: "Wij zetten uw privacy voorop.",
            bodyCollapsedLead: "Onze website maakt gebruik van cookies.",
            bodyLead: "Onze website maakt gebruik van de volgende soorten cookies. U kunt elk van deze individueel accepteren:",
            bodyCompactLead: "Wij gebruiken cookies om uw ervaring op onze website te verbeteren. U kunt uw voorkeuren bijwerken",
            cookiesNecessary: "Noodzakelijke cookies",
            cookiesNecessaryTooltip: "Noodzakelijke cookies zijn essentieel voor het goed functioneren van de website en haar functionaliteiten. Deze cookies zorgen er bijvoorbeeld voor dat u tussen pagina's kunt navigeren zonder dat de informatie die u in een formulier heeft ingevuld of de producten die u in een winkelwagen heeft geplaatst verdwijnen. Noodzakelijke cookies kunnen niet worden uitgeschakeld.",
            cookiesStatistics: "Statistische cookies",
            cookiesStatisticsTooltip: "Statistische cookies verzamelen informatie over het gebruik van websites en stellen ons in staat analyses uit te voeren, bijvoorbeeld over de meest bezochte pagina's en de navigatie van bezoekers op een website. Deze cookies worden gebruikt om het websitebezoek te vereenvoudigen en te versnellen en om het gebruiksgemak te verbeteren.",
            cookiesMarketing: "Marketing cookies",
            cookiesMarketingTooltip: "Marketing cookies helpen ons en onze advertentiepartners om u op onze websites en die van derden advertenties te tonen voor producten of diensten die voor u interessant kunnen zijn, of om onze advertenties te tonen wanneer u na het verlaten van onze websites verder surft op internet.",
            cookiesPreferences: "Voorkeur cookies",
            cookiesPreferenceseTooltip: "Voorkeur cookies stellen ons in staat om geavanceerde functies aan te bieden en gepersonaliseerde inhoud weer te geven. Deze cookies maken het bijvoorbeeld mogelijk om reeds verstrekte informatie (zoals taalkeuze) op te slaan of om u producten te tonen die u mogelijk ook interessant vindt op basis van de geraadpleegde artikelen.",
            privacyPolicyLead: "Raadpleeg ons",
            privacyPolicyLinkedText: "privacybeleid",
            linkRejectAll: "Doorgaan zonder accepteren",
            buttonRejectAll: "Alles weigeren",
            buttonAcceptAll: "Alles accepteren",
            buttonCustomize: "Voorkeuren aanpassen",
            biskouiSignaturePre: "De ",
            biskouiSignatureSwiss: "Zwitserse",
            biskouiSignaturePost: " Toestemming door ",
        },
        customize: {
            header: "Uw bezoek, uw keuze",
            bodyLead: "Welke cookies wilt u accepteren?",
            labelAcceptAll: "Alles accepteren",
            cookieType: {
                necessary: "Noodzakelijke cookies",
                statistics: "Statistische cookies",
                marketing: "Marketing cookies",
                preferences: "Voorkeur cookies",
            },
            privacyPolicyLead: "Raadpleeg ons",
            privacyPolicyLinkedText: "privacybeleid",
            buttonConfirm: "Mijn keuze bevestigen",
        },
        blocked: {
            text: "Oeps! De toestemmingsmodule is uitgeschakeld. Neem contact op met uw beheerder.",
            buttonClose: "Sluiten",
        },
    },
    pl: {
        home: {
            collapseToggleCollapse: "Zwiń",
            collapseToggleExpand: "Dowiedz się więcej",
            header: "Stawiamy Twoją prywatność na pierwszym miejscu.",
            bodyCollapsedLead: "Nasza strona używa plików cookie.",
            bodyLead: "Nasza strona internetowa wykorzystuje następujące rodzaje plików cookie. Możesz zaakceptować każdy z nich indywidualnie:",
            bodyCompactLead: "Używamy plików cookie, aby poprawić Twoje doświadczenia na naszej stronie internetowej. Możesz zaktualizować swoje preferencje",
            cookiesNecessary: "Niezbędne pliki cookie",
            cookiesNecessaryTooltip: "Niezbędne pliki cookie są kluczowe dla prawidłowego funkcjonowania strony internetowej i jej funkcjonalności. Te pliki cookie zapewniają na przykład, że możesz poruszać się między stronami bez utraty informacji wprowadzonych w formularzu lub produktów umieszczonych w koszyku. Niezbędnych plików cookie nie można wyłączyć.",
            cookiesStatistics: "Statystyczne pliki cookie",
            cookiesStatisticsTooltip: "Statystyczne pliki cookie zbierają informacje o tym, jak używane są strony internetowe i pozwalają nam przeprowadzać analizy, na przykład dotyczące najczęściej odwiedzanych stron i nawigacji użytkowników po stronie. Te pliki cookie służą do uproszczenia i przyspieszenia korystania ze strony oraz ogólnej poprawy komfortu użytkowania.",
            cookiesMarketing: "Marketingowe pliki cookie",
            cookiesMarketingTooltip: "Marketingowe pliki cookie pomagają nam i naszym partnerom reklamowym wyświetlać reklamy produktów lub usług, które mogą Cię zainteresować, na naszych stronach i stronach podmiotów trzecich, lub wyświetlać nasze reklamy, gdy kontynuujesz przeglądanie internetu po opuszczeniu naszych stron.",
            cookiesPreferences: "Preferencyjne pliki cookie",
            cookiesPreferenceseTooltip: "Preferencyjne pliki cookie pozwalają nam oferować zaawansowane funkcje i wyświetlać spersonalizowane treści. Te pliki cookie umożliwiają na przykład zapisanie już wprowadzonych informacji (takich jak wybór języka) lub pokazanie produktów, które mogą Cię zainteresować na podstawie przeglądanych artykułów.",
            privacyPolicyLead: "Zapoznaj się z naszą",
            privacyPolicyLinkedText: "polityką prywatności",
            linkRejectAll: "Kontynuuj bez akceptacji",
            buttonRejectAll: "Odrzuć wszystkie",
            buttonAcceptAll: "Zaakceptuj wszystkie",
            buttonCustomize: "Dostosuj wybór",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Szwajcarska",
            biskouiSignaturePost: " Zgoda przez ",
        },
        customize: {
            header: "Twoja wizyta, Twój wybór",
            bodyLead: "Które pliki cookie chcesz zaakceptować?",
            labelAcceptAll: "Zaakceptuj wszystkie",
            cookieType: {
                necessary: "Niezbędne pliki cookie",
                statistics: "Statystyczne pliki cookie",
                marketing: "Marketingowe pliki cookie",
                preferences: "Preferencyjne pliki cookie",
            },
            privacyPolicyLead: "Zapoznaj się z naszą",
            privacyPolicyLinkedText: "polityką prywatności",
            buttonConfirm: "Potwierdź mój wybór",
        },
        blocked: {
            text: "Ups! Moduł zgody jest wyłączony. Skontaktuj się z administratorem.",
            buttonClose: "Zamknij",
        },
    },
    ru: {
        home: {
            collapseToggleCollapse: "Свернуть",
            collapseToggleExpand: "Подробнее",
            header: "Мы ставим вашу конфиденциальность на первое место.",
            bodyCollapsedLead: "Наш сайт использует файлы cookie.",
            bodyLead: "Наш сайт использует следующие типы файлов cookie. Вы можете принять каждый из них по отдельности:",
            bodyCompactLead: "Мы используем файлы cookie для улучшения вашего опыта на нашем сайте. Вы можете обновить свои предпочтения",
            cookiesNecessary: "Необходимые файлы cookie",
            cookiesNecessaryTooltip: "Необходимые файлы cookie важны для правильной работы веб-сайта и его функций. Эти файлы cookie обеспечивают, например, возможность перемещаться между страницами без потери информации, введенной в форму, или товаров, помещенных в корзину. Необходимые файлы cookie нельзя отключить.",
            cookiesStatistics: "Статистические файлы cookie",
            cookiesStatisticsTooltip: "Статистические файлы cookie собирают информацию об использовании веб-сайтов и позволяют нам проводить анализ, например, наиболее посещаемых страницах и навигации посетителей по сайту. Эти файлы cookie используются для упрощения и ускорения посещения веб-сайта и улучшения удобства использования.",
            cookiesMarketing: "Маркетинговые файлы cookie",
            cookiesMarketingTooltip: "Маркетинговые файлы cookie помогают нам и нашим рекламным партнерам показывать вам рекламу продуктов или услуг, которые могут вас заинтересовать, на наших сайтах и сайтах третьих лиц, или отображать нашу рекламу, когда вы продолжаете просматривать интернет после ухода с наших сайтов.",
            cookiesPreferences: "Файлы cookie предпочтений",
            cookiesPreferenceseTooltip: "Файлы cookie предпочтений позволяют нам предлагать расширенные функции и отображать персонализированный контент. Эти файлы cookie позволяют, например, сохранять уже предоставленную информацию (такую как выбор языка) или показывать вам продукты, которые могут вас заинтересовать, на основе просмотренных статей.",
            privacyPolicyLead: "Ознакомьтесь с нашей",
            privacyPolicyLinkedText: "политикой конфиденциальности",
            linkRejectAll: "Продолжить без принятия",
            buttonRejectAll: "Отклонить все",
            buttonAcceptAll: "Принять все",
            buttonCustomize: "Настроить выбор",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Швейцарское",
            biskouiSignaturePost: " Согласие от ",
        },
        customize: {
            header: "Ваш визит, ваш выбор",
            bodyLead: "Какие файлы cookie вы хотите принять?",
            labelAcceptAll: "Принять все",
            cookieType: {
                necessary: "Необходимые файлы cookie",
                statistics: "Статистические файлы cookie",
                marketing: "Маркетинговые файлы cookie",
                preferences: "Файлы cookie предпочтений",
            },
            privacyPolicyLead: "Ознакомьтесь с нашей",
            privacyPolicyLinkedText: "политикой конфиденциальности",
            buttonConfirm: "Подтвердить мой выбор",
        },
        blocked: {
            text: "Упс! Модуль согласия отключен. Пожалуйста, обратитесь к администратору.",
            buttonClose: "Закрыть",
        },
    },
    uk: {
        home: {
            collapseToggleCollapse: "Згорнути",
            collapseToggleExpand: "Дізнатися більше",
            header: "Ми ставимо вашу конфіденційність на перше місце.",
            bodyCollapsedLead: "Наш сайт використовує файли cookie.",
            bodyLead: "Наш сайт використовує наступні типи файлів cookie. Ви можете прийняти кожен з них окремо:",
            bodyCompactLead: "Ми використовуємо файли cookie для покращення вашого досвіду на нашому сайті. Ви можете оновити свої налаштування",
            cookiesNecessary: "Необхідні файли cookie",
            cookiesNecessaryTooltip: "Необхідні файли cookie важливі для правильної роботи веб сайту та його функцій. Ці файли cookie забезпечують, на приклад, можливість переміщатися між сторінками без губитка інформації унетої у форму або продуктів ставлених у корпус. Необов'язкові файли cookie не можна вимкнути.",
            cookiesStatistics: "Статистичні файли cookie",
            cookiesStatisticsTooltip: "Статистичні файли cookie збирають інформацію про те як веб сайти користуються і дозволяють нам проводити аналізи, на приклад, про найбільш відвідувані сторінки і навигацію відвідувачів на сайті. Ці файли cookie використовуються для спрощення і прискорення відвідування сайту і покращення удобності користування.",
            cookiesMarketing: "Маркетингові файли cookie",
            cookiesMarketingTooltip: "Маркетингові файли cookie допомагають нам і нашим рекламним партнерам показувати вам рекламу для продуктів або послуг які могли б вас зацікавити на наших сайтах і сайтах третіх осіб або показувати наші реклами коли ви продовжуєте переглядати інтернет після нашого сайту.",
            cookiesPreferences: "Файли cookie налаштувань",
            cookiesPreferenceseTooltip: "Файли cookie налаштувань дозволяють нам пропонувати розширені функції і показувати персоналізований контент. Ці файли cookie дозволяють, на приклад, зберігати вже надані інформації (такі як вибір мови) або показувати вам продукти які могли б вас зацікавити на основі переглянутих статей.",
            privacyPolicyLead: "Прочитайте нашу",
            privacyPolicyLinkedText: "політику конфіденційності",
            linkRejectAll: "Наступити без прийняття",
            buttonRejectAll: "Відхилити все",
            buttonAcceptAll: "Прихвати все",
            buttonCustomize: "Налаштувати вибір",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Шваєцька",
            biskouiSignaturePost: " Сагласність від ",
        },
        customize: {
            header: "Ваша візит, ваш вибір",
            bodyLead: "Які файли cookie ви хочете прийняти?",
            labelAcceptAll: "Прихвати все",
            cookieType: {
                necessary: "Необхідні файли cookie",
                statistics: "Статистичні файли cookie",
                marketing: "Маркетингові файли cookie",
                preferences: "Файли cookie налаштувань",
            },
            privacyPolicyLead: "Прочитайте нашу",
            privacyPolicyLinkedText: "політику конфіденційності",
            buttonConfirm: "Потвердити мій вибір",
        },
        blocked: {
            text: "Упс! Модуль згоди вимкнено. Будь ласка, зверніться до адміністратора.",
            buttonClose: "Закрити",
        },
    },
    ro: {
        home: {
            collapseToggleCollapse: "Restrânge",
            collapseToggleExpand: "Află mai multe",
            header: "Punem confidențialitatea ta pe primul loc.",
            bodyCollapsedLead: "Site-ul nostru folosește cookie-uri.",
            bodyLead: "Site-ul nostru folosește următoarele tipuri de cookie-uri. Poți accepta fiecare dintre ele în mod individual:",
            bodyCompactLead: "Folosim cookie-uri pentru a îmbunătăți experiența ta pe site-ul nostru. Poți actualiza preferințele tale",
            cookiesNecessary: "Cookie-uri necesare",
            cookiesNecessaryTooltip: "Cookie-urile necesare sunt esențiale pentru funcționarea corectă a site-ului web și a funcționalităților sale. Aceste cookie-uri asigură, de exemplu, că poți naviga între pagini fără a pierde informațiile introduse într-un formular sau produsele plasate în coș. Cookie-urile necesare nu pot fi dezactivate.",
            cookiesStatistics: "Cookie-uri statistice",
            cookiesStatisticsTooltip: "Cookie-urile statistice colectează informații despre modul în care sunt utilizate site-urile web și ne permit să efectuăm analize, de exemplu, despre cele mai vizitate pagini și navigarea vizitatorilor pe site. Aceste cookie-uri sunt utilizate pentru a simplifica și accelera vizita pe site și pentru a îmbunătăți confortul utilizării.",
            cookiesMarketing: "Cookie-uri de marketing",
            cookiesMarketingTooltip: "Cookie-urile de marketing ne ajută pe noi și pe partenerii noștri de publicitate să îți arătăm reclame pentru produse sau servicii care te-ar putea interesa, pe site-urile noastre și ale terților, sau să afișăm reclamele noastre când continui să navighezi pe internet după ce părăsești site-urile noastre.",
            cookiesPreferences: "Cookie-uri de preferințe",
            cookiesPreferenceseTooltip: "Cookie-urile de preferințe ne permit să oferim funcții avansate și să afișăm conținut personalizat. Aceste cookie-uri permit, de exemplu, salvarea informațiilor deja furnizate (cum ar fi alegerea limbii) sau să îți arătăm produse care te-ar putea interesa pe baza articolelor consultate.",
            privacyPolicyLead: "Consultă",
            privacyPolicyLinkedText: "politica noastră de confidențialitate",
            linkRejectAll: "Continuă fără acceptare",
            buttonRejectAll: "Respinge toate",
            buttonAcceptAll: "Acceptă toate",
            buttonCustomize: "Personalizează alegerea",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Elvețian",
            biskouiSignaturePost: " Consimțământ de la ",
        },
        customize: {
            header: "Vizita ta, alegerea ta",
            bodyLead: "Ce cookie-uri dorești să accepți?",
            labelAcceptAll: "Acceptă toate",
            cookieType: {
                necessary: "Cookie-uri necesare",
                statistics: "Cookie-uri statistice",
                marketing: "Cookie-uri de marketing",
                preferences: "Cookie-uri de preferințe",
            },
            privacyPolicyLead: "Consultă",
            privacyPolicyLinkedText: "politica noastră de confidențialitate",
            buttonConfirm: "Confirmă alegerea mea",
        },
        blocked: {
            text: "Ups! Modulul de consimțământ este dezactivat. Te rugăm să contactezi administratorul.",
            buttonClose: "Închide",
        },
    },
    el: {
        home: {
            collapseToggleCollapse: "Σύμπτυξη",
            collapseToggleExpand: "Μάθετε περισσότερα",
            header: "Βάζουμε το απόρρητό σας στην πρώτη θέση.",
            bodyCollapsedLead: "Ο ιστότοπός μας χρησιμοποιεί cookies.",
            bodyLead: "Ο ιστότοπός μας χρησιμοποιεί τους ακόλουθους τύπους cookies. Μπορείτε να αποδεχτείτε καθένα από αυτά ξεχωριστά:",
            bodyCompactLead: "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον ιστότοπό μας. Μπορείτε να ενημερώσετε τις προτιμήσεις σας",
            cookiesNecessary: "Απαραίτητα cookies",
            cookiesNecessaryTooltip: "Τα απαραίτητα cookies είναι σημαντικά για τη σωστή λειτουργία του ιστότοπου και των λειτουργιών του. Αυτά τα cookies διασφαλίζουν, για παράδειγμα, ότι μπορείτε να περιηγηθείτε μεταξύ σελίδων χωρίς να χάσετε πληροφορίες που έχετε εισάγει σε μια φόρμα ή προϊόντα που έχετε τοποθετήσει στο καλάθι. Τα απαραίτητα cookies δεν μπορούν να απενεργοποιηθούν.",
            cookiesStatistics: "Στατιστικά cookies",
            cookiesStatisticsTooltip: "Τα στατιστικά cookies συλλέγουν πληροφορίες σχετικά με τη χρήση των ιστοτόπων και μας επιτρέπουν να πραγματοποιούμε αναλύσεις, για παράδειγμα, σχετικά με τις πιο επισκεπτόμενες σελίδες και την πλοήγηση των επισκεπτών στον ιστότοπο. Αυτά τα cookies χρησιμοποιούνται για την απλοποίηση και επιτάχυνση της επίσκεψης στον ιστότοπο και τη βελτίωση της άνεσης χρήσης.",
            cookiesMarketing: "Cookies μάρκετινγκ",
            cookiesMarketingTooltip: "Τα cookies μάρκετινγκ βοηθούν εμάς και τους διαφημιστικούς μας συνεργάτες να σας δείχνουμε διαφημίσεις για προϊόντα ή υπηρεσίες που μπορεί να σας ενδιαφέρουν, στους ιστότοπούς μας και σε ιστότοπους τρίτων, ή να εμφανίζουμε τις διαφημίσεις μας όταν συνεχίζετε την περιήγηση στο διαδίκτυο αφού φύγετε από τους ιστότοπούς μας.",
            cookiesPreferences: "Cookies προτιμήσεων",
            cookiesPreferenceseTooltip: "Τα cookies προτιμήσεων μας επιτρέπουν να προσφέρουμε προηγμένες λειτουργίες και να εμφανίζουμε εξατομικευμένο περιεχόμενο. Αυτά τα cookies επιτρέπουν, για παράδειγμα, την αποθήκευση πληροφοριών που έχουν ήδη παρασχεθεί (όπως η επιλογή γλώσσας) ή να σας δείχνουμε προϊόντα που μπορεί να σας ενδιαφέρουν με βάση τα άρθρα που έχετε συμβουλευτεί.",
            privacyPolicyLead: "Διαβάστε την",
            privacyPolicyLinkedText: "πολιτική απορρήτου μας",
            linkRejectAll: "Συνέχεια χωρίς αποδοχή",
            buttonRejectAll: "Απόρριψη όλων",
            buttonAcceptAll: "Αποδοχή όλων",
            buttonCustomize: "Προσαρμογή επιλογών",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Ελβετική",
            biskouiSignaturePost: " Συγκατάθεση από ",
        },
        customize: {
            header: "Η επίσκεψή σας, η επιλογή σας",
            bodyLead: "Ποια cookies θέλετε να αποδεχτείτε;",
            labelAcceptAll: "Αποδοχή όλων",
            cookieType: {
                necessary: "Απαραίτητα cookies",
                statistics: "Στατιστικά cookies",
                marketing: "Cookies μάρκετινγκ",
                preferences: "Cookies προτιμήσεων",
            },
            privacyPolicyLead: "Διαβάστε την",
            privacyPolicyLinkedText: "πολιτική απορρήτου μας",
            buttonConfirm: "Επιβεβαίωση επιλογών",
        },
        blocked: {
            text: "Ωχ! Η μονάδα συγκατάθεσης είναι απενεργοποιημένη. Παρακαλούμε επικοινωνήστε με τον διαχειριστή.",
            buttonClose: "Κλείσιμο",
        },
    },
    cs: {
        home: {
            collapseToggleCollapse: "Sbalit",
            collapseToggleExpand: "Více informací",
            header: "Vaše soukromí je pro nás na prvním místě.",
            bodyCollapsedLead: "Naše stránky používají soubory cookie.",
            bodyLead: "Naše stránky používají následující typy souborů cookie. Můžete přijmout každý z nich jednotlivě:",
            bodyCompactLead: "Používáme soubory cookie pro zlepšení vašeho zážitku na našich stránkách. Můžete aktualizovat své preference",
            cookiesNecessary: "Nezbytné soubory cookie",
            cookiesNecessaryTooltip: "Nezbytné soubory cookie jsou důležité pro správné fungování webových stránek a jejich funkcí. Tyto soubory cookie zajišťují například to, že se můžete pohybovat mezi stránkami bez ztráty informací zadaných do formuláře nebo produktů vložených do košíku. Nezbytné soubory cookie nelze vypnout.",
            cookiesStatistics: "Statistické soubory cookie",
            cookiesStatisticsTooltip: "Statistické soubory cookie shromažďují informace o tom, jak jsou webové stránky používány, a umožňují nám provádět analýzy, například o nejnavštěvovanějších stránkách a navigaci návštěvníků na webu. Tyto soubory cookie slouží ke zjednodušení a zrychlení návštěvy webu a ke zlepšení uživatelského komfortu.",
            cookiesMarketing: "Marketingové soubory cookie",
            cookiesMarketingTooltip: "Marketingové soubory cookie nám a našim reklamním partnerům pomáhají zobrazovat vám reklamy na produkty nebo služby, které by vás mohly zajímat, na našich stránkách a stránkách třetích stran, nebo zobrazovat naše reklamy, když pokračujete v prohlížení internetu po opuštění našich stránek.",
            cookiesPreferences: "Preferenční soubory cookie",
            cookiesPreferenceseTooltip: "Preferenční soubory cookie nám umožňují nabízet pokročilé funkce a zobrazovat personalizovaný obsah. Tyto soubory cookie umožňují například ukládat již poskytnuté informace (jako je volba jazyka) nebo vám ukazovat produkty, které by vás mohly zajímat na základě prohlížených článků.",
            privacyPolicyLead: "Přečtěte si naše",
            privacyPolicyLinkedText: "zásady ochrany osobních údajů",
            linkRejectAll: "Pokračovat bez přijetí",
            buttonRejectAll: "Odmítnout vše",
            buttonAcceptAll: "Přijmout vše",
            buttonCustomize: "Přizpůsobit volbu",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Švýcarský",
            biskouiSignaturePost: " Souhlas od ",
        },
        customize: {
            header: "Vaše návštěva, vaše volba",
            bodyLead: "Které soubory cookie chcete přijmout?",
            labelAcceptAll: "Přijmout vše",
            cookieType: {
                necessary: "Nezbytné soubory cookie",
                statistics: "Statistické soubory cookie",
                marketing: "Marketingové soubory cookie",
                preferences: "Preferenční soubory cookie",
            },
            privacyPolicyLead: "Přečtěte si naše",
            privacyPolicyLinkedText: "zásady ochrany osobních údajů",
            buttonConfirm: "Potvrdit mou volbu",
        },
        blocked: {
            text: "Ups! Modul souhlasu je deaktivován. Kontaktujte prosím správce.",
            buttonClose: "Zavřít",
        },
    },
    tr: {
        home: {
            collapseToggleCollapse: "Daralt",
            collapseToggleExpand: "Daha fazla bilgi",
            header: "Gizliliğinizi ön planda tutuyoruz.",
            bodyCollapsedLead: "Web sitemiz çerezler kullanmaktadır.",
            bodyLead: "Web sitemiz aşağıdaki çerez türlerini kullanmaktadır. Bunların her birini ayrı ayrı kabul edebilirsiniz:",
            bodyCompactLead: "Web sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. Tercihlerinizi güncelleyebilirsiniz",
            cookiesNecessary: "Gerekli çerezler",
            cookiesNecessaryTooltip: "Gerekli çerezler, web sitesinin ve işlevlerinin düzgün çalışması için önemlidir. Bu çerezler, örneğin bir forma girilen bilgilerin veya sepete eklenen ürünlerin kaybolmadan sayfalar arasında gezinebilmenizi sağlar. Gerekli çerezler devre dışı bırakılamaz.",
            cookiesStatistics: "İstatistik çerezleri",
            cookiesStatisticsTooltip: "İstatistik çerezleri, web sitelerinin nasıl kullanıldığı hakkında bilgi toplar ve en çok ziyaret edilen sayfalar ve ziyaretçilerin sitedeki gezinmesi gibi konularda analiz yapmamızı sağlar. Bu çerezler, site ziyaretini basitleştirmek ve hızlandırmak ve kullanım konforunu artırmak için kullanılır.",
            cookiesMarketing: "Pazarlama çerezleri",
            cookiesMarketingTooltip: "Pazarlama çerezleri, bize ve reklam ortaklarımıza, web sitelerimizde ve üçüncü taraf sitelerinde ilginizi çekebilecek ürün veya hizmetlerin reklamlarını göstermemize veya web sitelerimizden ayrıldıktan sonra internette gezinmeye devam ettiğinizde reklamlarımızı göstermemize yardımcı olur.",
            cookiesPreferences: "Tercih çerezleri",
            cookiesPreferenceseTooltip: "Tercih çerezleri, gelişmiş özellikler sunmamızı ve kişiselleştirilmiş içerik göstermemizi sağlar. Bu çerezler, örneğin daha önce sağlanan bilgileri (dil seçimi gibi) kaydetmeyi veya incelenen makalelere göre ilginizi çekebilecek ürünleri göstermeyi mümkün kılar.",
            privacyPolicyLead: "Gizlilik politikamızı",
            privacyPolicyLinkedText: "inceleyin",
            linkRejectAll: "Kabul etmeden devam et",
            buttonRejectAll: "Tümünü reddet",
            buttonAcceptAll: "Tümünü kabul et",
            buttonCustomize: "Tercihleri özelleştir",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "İsviçre",
            biskouiSignaturePost: " Onayı - ",
        },
        customize: {
            header: "Sizin ziyaretiniz, sizin tercihiniz",
            bodyLead: "Hangi çerezleri kabul etmek istiyorsunuz?",
            labelAcceptAll: "Tümünü kabul et",
            cookieType: {
                necessary: "Gerekli çerezler",
                statistics: "İstatistik çerezleri",
                marketing: "Pazarlama çerezleri",
                preferences: "Tercih çerezleri",
            },
            privacyPolicyLead: "Gizlilik politikamızı",
            privacyPolicyLinkedText: "inceleyin",
            buttonConfirm: "Seçimimi onayla",
        },
        blocked: {
            text: "Ups! Onay modülü devre dışı. Lütfen yöneticinizle iletişime geçin.",
            buttonClose: "Kapat",
        },
    },
    sr: {
        home: {
            collapseToggleCollapse: "Сажми",
            collapseToggleExpand: "Сазнај више",
            header: "Стављамо вашу приватност на прво место.",
            bodyCollapsedLead: "Наш сајт користи колачиће.",
            bodyLead: "Наш сајт користи следеће врсте колачића. Можете прихватити сваки од њих појединачно:",
            bodyCompactLead: "Користимо колачиће да бисмо побољшали ваше искуство на нашем сајту. Можете ажурирати своје преференције",
            cookiesNecessary: "Неопходни колачићи",
            cookiesNecessaryTooltip: "Неопходни колачићи су важни за правилно функционисање веб сајта и његових функција. Ови колачићи обезбеђују, на пример, да можете да се крећете између страница без губитка информација унетих у образац или производа стављених у корпус. Неопходни колачићи се не могу искључити.",
            cookiesStatistics: "Статистички колачићи",
            cookiesStatisticsTooltip: "Статистички колачићи прикупљају информације о томе како се веб сајтови користе и омогућавају нам да вршимо анализе, на пример, о најпосећенијим страницама и навигацији посетилаца на сајту. Ови колачићи се користе за поједностављивање и убрзавање посете сајту и побољшање удобности коришћења.",
            cookiesMarketing: "Маркетиншки колачићи",
            cookiesMarketingTooltip: "Маркетиншки колачићи помажу нама и нашим рекламним партнерима да вам приказујемо рекламе за производе или услуге које би вас могле занимати, на нашим сајтовима и сајтовима трећих страна, или да приказујемо наше рекламе када наставите да прегледате интернет након напуштања наших сајтова.",
            cookiesPreferences: "Колачићи преференција",
            cookiesPreferenceseTooltip: "Колачићи преференција нам омогућавају да понудимо напредне функције и прикажемо персонализовани садржај. Ови колачићи омогућавају, на пример, чување већ пружених информација (као што је избор језика) или приказивање производа који би вас могли занимати на основу прегледаних чланака.",
            privacyPolicyLead: "Прочитајте нашу",
            privacyPolicyLinkedText: "политику приватности",
            linkRejectAll: "Настави без прихватања",
            buttonRejectAll: "Одбиј све",
            buttonAcceptAll: "Прихвати све",
            buttonCustomize: "Прилагоди избор",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "Швајцарска",
            biskouiSignaturePost: " Сагласност од ",
        },
        customize: {
            header: "Ваша посета, ваш избор",
            bodyLead: "Које колачиће желите да прихватите?",
            labelAcceptAll: "Прихвати све",
            cookieType: {
                necessary: "Неопходни колачићи",
                statistics: "Статистички колачићи",
                marketing: "Маркетиншки колачићи",
                preferences: "Колачићи преференција",
            },
            privacyPolicyLead: "Прочитајте нашу",
            privacyPolicyLinkedText: "политику приватности",
            buttonConfirm: "Потврди мој избор",
        },
        blocked: {
            text: "Упс! Модул за сагласност је деактивиран. Молимо контактирајте администратора.",
            buttonClose: "Затвори",
        },
    },
    ko: {
        home: {
            collapseToggleCollapse: "접기",
            collapseToggleExpand: "더 알아보기",
            header: "귀하의 개인정보 보호를 최우선으로 생각합니다.",
            bodyCollapsedLead: "본 웹사이트는 쿠키를 사용합니다.",
            bodyLead: "본 웹사이트는 다음과 같은 유형의 쿠키를 사용합니다. 각각의 쿠키를 개별적으로 수락하실 수 있습니다:",
            bodyCompactLead: "당사는 웹사이트에서의 경험을 향상시키기 위해 쿠키를 사용합니다. 귀하의 선호도를 업데이트하실 수 있습니다",
            cookiesNecessary: "필수 쿠키",
            cookiesNecessaryTooltip: "필수 쿠키는 웹사이트와 그 기능이 올바르게 작동하는 데 필수적입니다. 예를 들어, 양식에 입력한 정보나 장바구니에 담은 상품이 사라지지 않고 페이지 간 이동이 가능하도록 합니다. 필수 쿠키는 비활성화할 수 없습니다.",
            cookiesStatistics: "통계 쿠키",
            cookiesStatisticsTooltip: "통계 쿠키는 웹사이트 사용 방식에 대한 정보를 수집하여 가장 많이 방문한 페이지와 방문자의 웹사이트 탐색 등에 대한 분석을 가능하게 합니다. 이러한 쿠키는 웹사이트 방문을 단순화하고 가속화하며 전반적인 사용자 편의성을 향상시키는 데 사용됩니다.",
            cookiesMarketing: "마케팅 쿠키",
            cookiesMarketingTooltip: "마케팅 쿠키는 당사와 광고 파트너가 귀하의 관심사에 맞는 제품이나 서비스의 광고를 당사 웹사이트나 제3자 웹사이트에서 표시하거나, 당사 웹사이트를 떠난 후 인터넷 검색을 계속할 때 당사의 광고를 표시하는 데 도움을 줍니다.",
            cookiesPreferences: "환경설정 쿠키",
            cookiesPreferenceseTooltip: "환경설정 쿠키를 통해 고급 기능을 제공하고 개인화된 콘텐츠를 표시할 수 있습니다. 예를 들어, 이미 제공된 정보(언어 선택 등)를 저장하거나 조회한 게시물을 기반으로 귀하의 관심사에 맞는 제품을 표시할 수 있습니다.",
            privacyPolicyLead: "당사의",
            privacyPolicyLinkedText: "개인정보 처리방침",
            linkRejectAll: "수락하지 않고 계속하기",
            buttonRejectAll: "모두 거부",
            buttonAcceptAll: "모두 수락",
            buttonCustomize: "설정 사용자 지정",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "스위스",
            biskouiSignaturePost: " 동의 by ",
        },
        customize: {
            header: "귀하의 방문, 귀하의 선택",
            bodyLead: "어떤 쿠키를 수락하시겠습니까?",
            labelAcceptAll: "모두 수락",
            cookieType: {
                necessary: "필수 쿠키",
                statistics: "통계 쿠키",
                marketing: "마케팅 쿠키",
                preferences: "환경설정 쿠키",
            },
            privacyPolicyLead: "당사의",
            privacyPolicyLinkedText: "개인정보 처리방침",
            buttonConfirm: "선택 확인",
        },
        blocked: {
            text: "죄송합니다! 동의 모듈이 비활성화되어 있습니다. 관리자에게 문의해 주시기 바랍니다.",
            buttonClose: "닫기",
        },
    },
    ja: {
        home: {
            collapseToggleCollapse: "折りたたむ",
            collapseToggleExpand: "詳細を表示",
            header: "お客様のプライバシーを第一に考えております。",
            bodyCollapsedLead: "当ウェブサイトではクッキーを使用しています。",
            bodyLead: "当ウェブサイトでは以下の種類のクッキーを使用しています。それぞれ個別に承諾いただけます：",
            bodyCompactLead: "当社はウェブサイトでの体験を向上させるためにクッキーを使用しています。設定を更新することができます",
            cookiesNecessary: "必須クッキー",
            cookiesNecessaryTooltip: "必須クッキーはウェブサイトとその機能が正しく動作するために不可欠です。例えば、フォームに入力した情報やショッピングカートに入れた商品を失うことなく、ページ間を移動できるようにします。必須クッキーは無効にすることができません。",
            cookiesStatistics: "統計クッキー",
            cookiesStatisticsTooltip: "統計クッキーは、ウェブサイトの使用状況に関する情報を収集し、最もアクセスの多いページや訪問者のナビゲーションなどの分析を可能にします。これらのクッキーは、ウェブサイトの訪問を簡素化・迅速化し、全体的な使用感を向上させるために使用されます。",
            cookiesMarketing: "マーケティングクッキー",
            cookiesMarketingTooltip: "マーケティングクッキーは、当社と広告パートナーが、お客様の興味に合わせた商品やサービスの広告を当社ウェブサイトや第三者のウェブサイトで表示したり、当社ウェブサイトを離れた後にインターネット閲覧を続ける際に当社の広告を表示したりするのに役立ちます。",
            cookiesPreferences: "設定クッキー",
            cookiesPreferenceseTooltip: "設定クッキーにより、高度な機能とパーソナライズされたコンテンツを提供することができます。例えば、既に提供された情報（言語選択など）を保存したり、閲覧した記事に基づいてお客様の興味に合わせた商品を表示したりすることができます。",
            privacyPolicyLead: "当社の",
            privacyPolicyLinkedText: "プライバシーポリシー",
            linkRejectAll: "承諾せずに続ける",
            buttonRejectAll: "すべて拒否",
            buttonAcceptAll: "すべて承諾",
            buttonCustomize: "設定をカスタマイズ",
            biskouiSignaturePre: "",
            biskouiSignatureSwiss: "スイス",
            biskouiSignaturePost: " 同意 by ",
        },
        customize: {
            header: "お客様のご訪問、お客様のご選択",
            bodyLead: "どのCookieを承諾されますか？",
            labelAcceptAll: "すべて承諾",
            cookieType: {
                necessary: "必須クッキー",
                statistics: "統計クッキー",
                marketing: "マーケティングクッキー",
                preferences: "設定クッキー",
            },
            privacyPolicyLead: "当社の",
            privacyPolicyLinkedText: "プライバシーポリシー",
            buttonConfirm: "選択を確定",
        },
        blocked: {
            text: "申し訳ございません！同意モジュールが無効になっています。管理者にお問い合わせください。",
            buttonClose: "閉じる",
        },
    }
};
function translations(code) {
    return TEXTS[code];
}
export { translations };
//# sourceMappingURL=texts.js.map